import { render, staticRenderFns } from "./ResetSuccess.vue?vue&type=template&id=0d6713c4&"
import script from "./ResetSuccess.vue?vue&type=script&lang=js&"
export * from "./ResetSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports